const CATEGORY_WIDTH_REDUCTION = 4;

/**
 * Default percentage-based layout values for categories
 * These are the source of truth for category layouts and should be used by the frontend
 * for responsive layouts based on the actual canvas size.
 */
export const CATEGORY_LAYOUT_PERCENTAGES = {
  MARGIN: 4,
  WIDTH: 100 / 3 - CATEGORY_WIDTH_REDUCTION, // ~29.33%
  HEIGHT: 35,
  CATEGORY_SPACING: 3,
} as const;
